import * as types from './mutation-types';
import { defaultNfseNatureState } from './state';

export default {
  [types.RESET_NFSE_NATURE](state) {
    Object.assign(state.nfseNature, defaultNfseNatureState());
  },
  [types.SET_SUMMARY_NFSE_NATURES](state, payload) {
    state.summaryNfseNatures = payload;
  },
  [types.SET_PAGINATION_NFSE_NATURES](state, payload) {
    state.paginationNfseNatures = payload;
  },
  [types.SET_DETAILED_NFSE_NATURE](state, payload) {
    state.nfseNature = payload;
  },
  [types.SET_NFSE_NATURES_WARNINGS](state, payload) {
    state.nfseWarnings = payload;
  },
};
